import React from "react";
import "../../styles/footer.css";
import lg from "../Assets/iste_logo.png";
const Footer = () => {
  function getYear() {
    return new Date().getFullYear();
  }
  return (
    <footer>
      <section className="foot py-5 footer-color">
        <div className="container detailed-footer">
          <div className="row">
            <img
              src={lg}
              alt="ISTE Logo"
              width="30"
              height="30"
              className="lg d-inline-block align-top"
            />{" "}
            <div className="col-md-3">
              <p className="footer-content">
                ISTE is a Technical Society in SRM Institute of Science and
                Technology, Delhi NCR.
              </p>
            </div>
            <div className="col-md-3">
              <h4 className="footer-content">
                <b>Quick Links</b>
              </h4>
              <ul className="list-unstyled mt-3">
                <li>
                  <a href="/aboutus" className="link-footer">
                    About Us
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/contact" className="link-footer">
                    Contact Us
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/team" className="link-footer">
                    Our Team
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/" className="link-footer">
                    Our Events
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-3">
              <h4 className="footer-content">
                <b>Quick Links</b>
              </h4>
              <ul className="list-unstyled mt-3">
                <li>
                  <a href="/" className="link-footer">
                    Home
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/" className="link-footer">
                    Coming Soon
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/privacypolicy" className="link-footer">
                    Privacy Policy
                  </a>
                </li>
                <div className="mb-2"></div>
                <li>
                  <a href="/termsandconsitions" className="link-footer">
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center ">
              <div className="copyright">
                <p>
                  Copyright © <span>{getYear()} </span>{" "}
                  <a href="/" className="transition">
                    ISTE SRM NCR
                  </a>{" "}
                  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
